import { Alert, IconButton, StackProps } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Stack from '@mui/material/Stack';
import { CloudArrowUp as CloudArrowUpIcon } from '@phosphor-icons/react/dist/ssr/CloudArrowUp';
import { Question } from '@phosphor-icons/react/dist/ssr/Question';
import { useFormik } from 'formik';

import { FileDropzone } from '~ui-components/components/atoms/file-dropzone';
import {
	BlankFilesList,
	FilesListWithProgress,
	FilesListWithProgressProps,
} from '~ui-components/components/molecules/uploader';

export type DatasetUpdateShapeFormValues = {
	shapeFile: File[] | null;
};

type Props = StackProps & {
	form: ReturnType<typeof useFormik<DatasetUpdateShapeFormValues>>;
	uploadProgresses: FilesListWithProgressProps['progresses'];
};

const url =
	'https://help.mangomap.com/hc/en-us/articles/360022250631-Shapefile-SHP';

export const DatasetUpdateShapeForm = ({ form, uploadProgresses }: Props) => {
	return (
		<Card>
			<CardHeader
				avatar={
					<Avatar>
						<CloudArrowUpIcon fontSize="var(--Icon-fontSize)" />
					</Avatar>
				}
				title="Shape File"
				action={
					<IconButton href={url} target="_blank">
						<Question fontSize="var(--Icon-fontSize)" />
					</IconButton>
				}
			/>
			<CardContent>
				<Stack spacing={3}>
					<FileDropzone
						accept={{ shp: [], dbf: [], shx: [], prj: [] }}
						caption="Max individual file size is 200MB"
						onDrop={(files) => form.setFieldValue('shapeFile', files)}
					/>
					{form.values.shapeFile?.length ? (
						<FilesListWithProgress
							requiredFiles={['.shp', '.dbf', '.shx', '.prj']}
							files={form.values.shapeFile || []}
							progresses={uploadProgresses}
							onFilesRemoved={() => form.setFieldValue('shapeFile', [])}
						/>
					) : (
						<BlankFilesList requiredFiles={['.shp', '.dbf', '.shx', '.prj']} />
					)}
					<Alert severity="info">
						Your layer data will be updated across all maps to reflect any
						changes while maintaining your style preferences.
					</Alert>
				</Stack>
			</CardContent>
			{form.values.shapeFile?.length === 4 ? (
				<CardActions sx={{ justifyContent: 'flex-end' }}>
					<Button color="secondary">Cancel</Button>
					<Button variant="contained">Save changes</Button>
				</CardActions>
			) : null}
		</Card>
	);
};
